<div class="rx-copy-from-tooth-menu">
	<div class="rx-copy-from-tooth-menu__trigger-wrap" cdkOverlayOrigin #overlayOrigin="cdkOverlayOrigin">
		<button
			type="button"
			tlkButton
			variant="secondary"
			size="m"
			data-testid="rx-copy-from-tooth-menu-trigger-button"
			class="rx-copy-from-tooth-menu__trigger"
			[class.rx-copy-from-tooth-menu__trigger--open]="isOpen"
			[disabled]="isTriggerDisabled"
			[attr.aria-expanded]="isOpen"
			[attr.aria-haspopup]="'menu'"
			(click)="toggleMenu($event)"
		>
			<tlk-copy-icon class="rx-copy-from-tooth-menu__trigger-icon tlk-icon_size_m" />
			<span class="rx-copy-from-tooth-menu__trigger-label">{{ 'TeethDiagram.CopyFromButton' | translate }}</span>
		</button>
	</div>

	<ng-template
		cdkConnectedOverlay
		[cdkConnectedOverlayOrigin]="overlayOrigin"
		[cdkConnectedOverlayOpen]="isOpen"
		[cdkConnectedOverlayPositions]="overlayPositions"
		[cdkConnectedOverlayFlexibleDimensions]="true"
		[cdkConnectedOverlayViewportMargin]="overlayViewportMargin"
		[cdkConnectedOverlayHasBackdrop]="true"
		[cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
		(backdropClick)="onBackdropClick()"
	>
		<div class="rx-copy-from-tooth-menu rx-copy-from-tooth-menu--dropdown" data-testid="rx-copy-from-tooth-menu-dropdown">
			<div class="rx-copy-from-tooth-menu__panel">
				<div
					class="rx-copy-from-tooth-menu__panel-heading"
					data-testid="rx-copy-from-tooth-menu-panel-heading"
					[attr.title]="'TeethDiagram.SelectToothCopyFrom' | translate"
				>
					{{ 'TeethDiagram.SelectToothCopyFrom' | translate }}
				</div>
				<div
					class="rx-copy-from-tooth-menu__list"
					role="menu"
					[attr.aria-label]="'TeethDiagram.SelectToothCopyFrom' | translate"
				>
					<div *ngFor="let item of sourceMenuItems; trackBy: trackByMenuItemToothId" class="rx-copy-from-tooth-menu__item">
						<button
							type="button"
							class="rx-copy-from-tooth-menu__row"
							role="menuitem"
							[attr.aria-label]="item.toothLabel + ', ' + item.detailLine"
							(click)="onRowSelected(item.toothId, $event)"
						>
							<div class="rx-copy-from-tooth-menu__item-body">
								<div class="rx-copy-from-tooth-menu__item-header">
									<span class="rx-copy-from-tooth-menu__item-tooth-label">{{ item.toothLabel }}</span>
									<rx-intuitive-indication-badge
										*ngIf="item.indicationId !== defaultIndicationId"
										[indication]="item.indicationId"
										size="s"
									/>
								</div>
								<div class="rx-copy-from-tooth-menu__item-treatment-detail" [attr.title]="item.detailLine">{{ item.detailLine }}</div>
							</div>
						</button>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</div>
